import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import { default as SystemNotification } from './SystemNotification';
import SystemNotificationBranched from '../SystemNotification.dev_notification_vertical';
export * from './SystemNotification';
export default withFeatureBranch({
    dev_notification_vertical: SystemNotificationBranched,
})(SystemNotification);
//# sourceMappingURL=index.js.map